import { Controller } from 'stimulus';
import { columnFilterService } from '../libs/column_filter_service';

export default class extends Controller {
  toggle() {
    columnFilterService.toggleFilter(this);
  }
}
